export const TITLE = 'Max Count of Selected Answers';
